var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""},on:{"enter":_vm.animIn}},[_c('div',{class:{ 'panel': true, 'darken': _vm.darken }},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_vm._t("button")],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adbd78aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Panel.vue
// module id = null
// module chunks = 